import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { YogoWidgetProps } from "./YogoWidget.d";

export const YogoWidgetPart = (props: ComponentProps<PartData>) => {
  const { type } = (props.data as Partial<YogoWidgetProps>) ?? {};

  if (!type) {
    return <p>Velg en Yogo-widget.</p>;
  }

  return (
    <div className="container">
      <div className={type} />
    </div>
  );
};

export default YogoWidgetPart;
